<div class="d-flex justify-content-center align-items-center">
  @if (iconLeft) {
    <fa-icon [ngbTooltip]="tooltipLeft" class="me-1" size="lg" icon="{{iconLeft}}"></fa-icon>
  }
  <div class="d-flex">
    <label class="switch"
      [style.background-color]="backgroundColor ? backgroundColor : 'var(--bs-ls-primary-500)'"><input
      [(ngModel)]="enabled" (ngModelChange)="changeValue($event)" type="checkbox"/>
    <div></div>
  </label>
</div>
@if (iconRight) {
  <fa-icon [ngbTooltip]="tooltipRight" class="ms-1" size="lg" icon="{{iconRight}}"></fa-icon>
}
</div>
